import React from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { window } from "@swa-ui/browser";
import { Button, Icon } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./CruiseBookingContainer.module.scss";

export const CruiseBookingContainer = () => {
  const { CRUISE_PAGE } = getBootstrapData("urls");

  return (
    <div className={styles.container}>
      <div className={styles.minHeightForSlim}>
        <div className={styles.content}>
          <div className={styles.text}>
            <Icon {...getIconProps()} />
            <span>{i18n("CruiseBookingContainer__DISCLAIMER")}</span>
          </div>
          <Button {...getCruiseRedirectButtonProps()}>
            {i18n("CruiseBookingContainer__SEARCH_BUTTON")}
          </Button>
        </div>
      </div>
    </div>
  );

  function getCruiseRedirectButtonProps() {
    return {
      "aria-label": i18n("CruiseBookingContainer__SEARCH_BUTTON_ARIA_LABEL"),
      externallyLinked: true,
      newWindow: true,
      onClick: handleCruiseRedirectButtonClick,
      ripple: true,
      styleType: "primary",
      suffixIcon: { name: "External", size: "size20" },
    };
  }

  function getIconProps() {
    return {
      name: "Cruise",
      role: "presentation",
      size: "size28",
    };
  }

  function handleCruiseRedirectButtonClick() {
    window.open(CRUISE_PAGE, "_blank");
  }
};
